import "./pdfWorker";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { ToastProvider } from "./Context/useToast";
import App from "./App";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
   <>
      <BrowserRouter>
         <QueryClientProvider client={queryClient}>
            <ToastProvider>
               <App />
            </ToastProvider>
         </QueryClientProvider>
      </BrowserRouter>
      <div className="main-backdrop"></div>
   </>
);
